import React, { Component } from 'react';
import { ListGroup, Alert, Row, Col } from 'react-bootstrap';

import "react-datepicker/dist/react-datepicker.css";

const CURRENT_STEP = 'TELEHEALTH_TYPE';

class TelehealthType extends Component {
  render() {
    if (this.props.currentStep !== CURRENT_STEP) {
      return null;
    }

    return (
      <div className="card axs-shadow">
        <div className="card-body">
          <h3 className="d-inline font-weight-bold">Schedule Telehealth Appointment</h3>&nbsp;
          <h6 className="ml-3 d-inline font-weight-bold text-muted">Telehealth Type</h6>
          <hr />

          <ListGroup horizontal className="text-center mb-5">
            <ListGroup.Item
              action
              as="button"
              className="btn btn-outline-info py-4 m-4"
              onClick={() => {
                this.props.setValue('telehealthType', 'video');
                this.props.setValue('currentStep', 'TELEHEALTH_REAL_TIME_DETAILS');
              }}>
              <>
                <Row>
                  <Col>
                    <h5>Real-Time Video</h5>
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col className="pl-4 pb-5 mb-3 text-left px-5">
                    <p>This is a video face-to-face encounter between the provider and patient augmented by digital information provided by the patient prior to the visit.</p>
                  </Col>
                </Row>
              </>
            </ListGroup.Item>
            <ListGroup.Item
              action
              as="button"
              className="btn btn-outline-primary py-4 m-4"
              style={{ borderLeftWidth: 1, borderBottomLeftRadius: "inherit" }}
              onClick={() => {
                this.props.setValue('telehealthType', 'messaging');
                this.props.setValue('currentStep', 'TELEHEALTH_REAL_TIME_DETAILS');
              }}>
              <>
                <Row>
                  <Col>
                    <h5>Asynchronous</h5>
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col className="pl-4 text-left px-5">
                    <p>This is a text based encounter between the provider and patient augmented by digital information provided by the patient prior to the visit.</p>

                    <p> You can still convert to real-time video during the appointment.</p>
                  </Col>
                </Row>
              </>
            </ListGroup.Item>
          </ListGroup>
        </div>
        <div className="card-footer">
          <div className="row">
            <div className="col-sm-2">
              <button
                onClick={this.props.backStep}
                type="submit" className="btn btn-outline-primary btn-block">Back</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TelehealthType;